<template>
    <div class="soon">
        <div class="soon__body maintenance">
            <div class="maintenance__img">
                <img src="/img/maintenance.png" alt="maintenance image">
            </div>
            <div class="maintenance__content">
                <p class="maintenance__title">Sorry, we're down for a bit of maintenance right now.</p>
                <p class="maintenance__msg">We'll be back and running soon.<br><br> Thank you for your patience. </p>
          </div>
        </div>
        <div class="soon__footer">
            <div class="soon__logo">
                <img src="/img/logo.png" alt="healthnow logo">
            </div>
            <div class="soon__partners">
                <p>in partnership with</p>
                <PartnerImg divclass="soon__partners--img"></PartnerImg>
            </div>
        </div>
    </div>
</template>
<script>
import PartnerImg from '../components/PartnerImg.vue';

export default {
  components: {
    PartnerImg,
  },
};
</script>
